import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('LegalEntityPerimeter', LegalEntityPerimeterData);

    /* @ngInject */
    function LegalEntityPerimeterData() {
        LegalEntityPerimeter.prototype = {
            build: build,
            buildEmpty: buildEmpty
        };

        function LegalEntityPerimeter(legalEntityPerimeterData) {
            if (!legalEntityPerimeterData) {
                this.buildEmpty();
            } else {
                this.build(legalEntityPerimeterData);
            }
        }

        return LegalEntityPerimeter;

        /////////////////////

        function buildEmpty() {
            this.code = null;
            this.name = null;
            this.beginDate = null;
            this.endDate = null;
            this.platformPath = null;
            this.isConfidential = null;
        }

        function build(legalEntityPerimeterData) {
            this.code = legalEntityPerimeterData.code || null;
            this.name = legalEntityPerimeterData.name || null;
            this.beginDate = legalEntityPerimeterData.beginDate ? new Date(legalEntityPerimeterData.beginDate) : null;
            this.endDate = legalEntityPerimeterData.endDate ? new Date(legalEntityPerimeterData.endDate) : null;
            this.platformPath = legalEntityPerimeterData.platformPath || null;
            this.isConfidential = legalEntityPerimeterData.isConfidential || null;
        }
    }
})();
